import { Box, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { useContext, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { Context } from '../../service/Context';
import VirtualizedListbox from '../../utils/UtilesBuscadores';
import { capitalizar } from '../../utils/UtilesComun';
import { AutocompleteApp, BadgeInfoApp, ButtonApp, TextFieldApp } from '../custom/CustomComponents';
import CrearJugadorModal from '../jugador/CrearJugadorModal';

const BarraBuscarJugador = ({ onSelectJugador, size = 'medium', fullWidth = false, md = 5 }) => {
  const modalRef = useRef(null);
  const navigate = useNavigate();
  const { idUsuario, obtenerTodosJugadores, todosJugadores } = useContext(Context);

  useEffect(() => {
    async function cargarDatos() {
      if (idUsuario && (todosJugadores === undefined || todosJugadores.length === 0)) {
        obtenerTodosJugadores();
      }
    }
    cargarDatos();
  }, [idUsuario, todosJugadores, obtenerTodosJugadores]);

  function clickJugador(jugador) {
    if (jugador !== null) {
      if (onSelectJugador) {
        onSelectJugador(jugador);
      } else {
        navigate(`/jugador/${jugador.idJugador}`);
      }
    }
  }

  const normalizeStr = (str) =>
    str
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

  const customFilterOptions = (options, { inputValue }) => {
    if (!inputValue) {
      return options;
    }

    const inputTerms = normalizeStr(inputValue)
      .split(' ')
      .filter((term) => term.length > 0);

    return options.filter((option) => {
      const normalizedLabel = normalizeStr(option.nombreJugador);
      // El jugador debe contener todas las palabras tecleadas (en cualquier orden)
      return inputTerms.every((term) => normalizedLabel.includes(term));
    });
  };

  const colMd = fullWidth ? 10 : md;

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} md={colMd} sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
        <Box sx={{ flexGrow: 1 }}>
          <AutocompleteApp
            noBorder
            filterOptions={customFilterOptions}
            onChange={(event, value) => clickJugador(value)}
            id="buscador-jugadores"
            ListboxComponent={VirtualizedListbox}
            options={todosJugadores || []}
            getOptionLabel={(option) => capitalizar(option.nombreJugador)}
            sx={{ backgroundColor: 'transparent' }}
            renderInput={(params) => (
              <TextFieldApp
                border={false}
                size={size}
                {...params}
                label="Buscar jugador..."
                inputProps={{ ...params.inputProps, id: 'buscador-jugadores-input', name: 'buscador-jugadores-input' }}
              />
            )}
            renderOption={(props, option) => [
              props,
              <Box key={option.idJugador} sx={{ display: 'flex', alignItems: 'center' }}>
                <BadgeInfoApp>{option.ano || '?'}</BadgeInfoApp>
                {capitalizar(option.nombreJugador)}
              </Box>,
            ]}
            componentsProps={{ popper: { style: { minWidth: '30%', width: 'auto' } } }}
          />
        </Box>
        <ButtonApp
          contrast
          onClick={() => modalRef.current?.handleOpen()}
          sx={{ whiteSpace: 'nowrap', py: 1, fontWeight: 'bold' }}
        >
          + Crear jugador
        </ButtonApp>
      </Grid>
      <CrearJugadorModal ref={modalRef} />
    </Grid>
  );
};

BarraBuscarJugador.propTypes = {
  onSelectJugador: PropTypes.func,
  size: PropTypes.string,
  fullWidth: PropTypes.bool,
  md: PropTypes.number,
};

export default BarraBuscarJugador;
